import { render, staticRenderFns } from "./UserTrainingModal2.vue?vue&type=template&id=41cbc23d&scoped=true"
import script from "../../../scripts/partials/UserTrainingModal2.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/UserTrainingModal2.js?vue&type=script&lang=js&external"
import style0 from "./UserTrainingModal2.vue?vue&type=style&index=0&id=41cbc23d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cbc23d",
  null
  
)

export default component.exports